import { render, staticRenderFns } from "./Blanklayout.vue?vue&type=template&id=587306af&"
import script from "./Blanklayout.vue?vue&type=script&lang=js&"
export * from "./Blanklayout.vue?vue&type=script&lang=js&"
import style0 from "./Blanklayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VApp } from 'vuetify/lib/components/VApp';
import { VDialog } from 'vuetify/lib/components/VDialog';
installComponents(component, {VApp,VDialog})
